import axios from "axios";
export default {
  data() {
    return {
      tenantId: this.realm,
      export: "",
      apiUrl: "",
      dialogSelectVersion: false,
      actionSelectVersion: "",
      projectVersions: [],
      selectedVersion:
        this.editedItem?.versions[this.editedItem.versions.length - 1],
    };
  },
  created() {
    this.apiUrl = this.mashupsListConfig.api;
    this.getMashupsList();
    sessionStorage.removeItem("mashup");
    sessionStorage.removeItem("mashupDebug");
  },
  methods: {
    getMashupsList() {
      this.loader = true;
      axios
        .get(
          this.apiUrl + "/" + this.tenantId + "/projects?withversions=true",
          this.opts,
        )
        .then((response) => {
          this.mashups = response.data;
          document.dispatchEvent(new CustomEvent("hide-welcome-loader"));
          this.loader = false;
        })
        .catch((err) => {
          this.setError(err, false);
          this.loader = false;
        });
    },
    createMashup(name) {
      axios
        .post(
          this.apiUrl + "/" + this.tenantId + "/projects",
          {
            title: name,
          },
          this.opts,
        )
        .then(() => {
          this.getMashupsList();
        })
        .catch((err) => {
          this.setError(err, false);
          this.loader = false;
        });
    },

    createMashupConfirm() {
      if (this.validateCreateForm()) {
        this.createMashup(this.editedItem.title);
        this.closeCreateMashup();
      }
    },
    closeCreateMashup() {
      this.dialogCreate = false;
      this.resetDialog();
      this.$refs.createForm.resetValidation();
    },
    deleteMashup(item) {
      this.editedIndex = this.mashups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteMashupConfirm() {
      axios
        .delete(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.editedItem._id,
          this.opts,
        )
        .then(() => {
          this.getMashupsList();
        })
        .catch((err) => {
          this.setError(err, false);
          this.loader = false;
        });
      this.closeDeleteMashup();
    },
    closeDeleteMashup() {
      this.dialogDelete = false;
      this.resetDialog();
    },

    resetDialog() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.numDelete = 1;
      });
    },
    deleteConfirm() {
      this.numDelete > 1
        ? this.deleteMultipleMashupConfirm()
        : this.deleteMashupConfirm();
    },
    deleteMultipleMashup() {
      this.dialogDelete = true;
      this.numDelete = 2;
    },
    deleteMultipleMashupConfirm() {
      let ids = this.extractMashupsId();
      axios
        .delete(this.apiUrl + "/" + this.tenantId + "/projects", {
          params: {
            ids,
          },
          ...this.opts,
        })
        .then(() => {
          this.getMashupsList();
          this.selected = [];
        })
        .catch((err) => {
          this.setError(err, false);
          this.loader = false;
        });
      this.closeDeleteMashup();
    },
    //Return an id array with the mashups that will be deleted
    extractMashupsId() {
      let ids = [];
      this.selected.forEach((el) => {
        ids.push(el._id);
      });
      return ids;
    },
    validateCreateForm() {
      return this.$refs.createForm.validate();
    },

    //DUPLICATE && EXPORT
    //Select version mashup
    selectMashupVersion(action, item) {
      this.editedIndex = this.mashups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.projectVersions = item.versions;
      //Assign last version as default
      this.selectedVersion =
        this.editedItem.versions[this.editedItem.versions.length - 1];
      this.actionSelectVersion = action;
      this.dialogSelectVersion = true;
    },
    //Confirm Duplicate or Export action
    versionMashupConfirm() {
      this.overlay = true;
      if (this.actionSelectVersion === "duplicate") {
        this.duplicateMashup(this.editedItem.title);
      } else {
        this.overlay = true;
        this.exportMashup(this.editedItem.title);
      }
      this.closeSelectVersion();
    },
    //Duplicate a Mashup
    duplicateMashup(name) {
      axios
        .post(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.editedItem._id +
            "/duplicate",
          {
            versionId: this.selectedVersion._id,
            title: name,
          },
          this.opts,
        )
        .then(() => {
          this.getMashupsList();
          this.snackbar = true;
          this.snackbarText = this.$t("strings.duplicate-mashup-text");
        })
        .catch((err) => {
          this.setError(err, false);
          this.loader = false;
        });
    },
    //Exports a Mashup
    exportMashup(title) {
      axios
        .get(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/projects/" +
            this.editedItem._id +
            "/versions/" +
            this.selectedVersion._id +
            "/export",
          this.opts,
        )
        .then((response) => {
          this.downloadMashup(
            response.data,
            title + " - " + this.selectedVersion.name,
          );
          this.editedItem = Object.assign({}, this.defaultItem);
        })
        .catch((err) => {
          this.setError(err, false);
          this.overlay = false;
        });
    },
    //Downloads exported Mashup
    downloadMashup(exportObj, exportName) {
      let fileURL = window.URL.createObjectURL(
        new Blob([JSON.stringify(exportObj)]),
        {
          type: "application/json",
        },
      );
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", exportName + ".json");
      fileLink.click();
      fileLink.remove();
      this.overlay = false;
    },
    //Closes Duplicate/Export modal and resets
    closeSelectVersion() {
      this.dialogSelectVersion = false;
      this.resetDialog();
    },

    //Open selected mashup in Editor (change page)
    routeToMashup(item) {
      let project = item._id;
      let version = item.versions[item.versions.length - 1]._id;
      this.$router.push({
        path: `/` + this.realm + `/draw/` + project + `/v/` + version + `/edit`,
      });
    },

    activateSnackbar(val, text) {
      this.snackbar = val;
      this.snackbarText = text;
    },
  },
};
